module.exports = __webpack_public_path__ + "static/media/article8.1d4d40db.webp";